// extracted by mini-css-extract-plugin
export default {"container":"ProfileMealCard_container__QUy6q","button":"ProfileMealCard_button__JGLV8"};